import React, { useEffect, useMemo } from 'react';
import { Line } from './styled';
import { useDispatch, useSelector } from 'react-redux';
import { updateInterval } from '@store/common/actions';
import { selector as commonSelector } from '@store/common';
import { applyFilter } from '@store/filterContainer/actions';
import { SummaryContainer } from '@components/summary-panel';
import DimensionContext from '@components/dimensions/DimensionContext';
import { useGetDimensionsList } from '@src/api/common/queryHooks';
import { DimensionTableContainer } from '@components/dimensions/components/DimensionTableContainer';
import { exploreLockedDimensionNames } from '@components/dimensions/typed';
import { cloneDeep } from 'lodash';
import { DATE_SHORTCUTS } from '@src/utils/constants';
import { calcShortcutInterval } from '@src/utils';
import { useInitialInfoStore } from '@src/emp-3.0/store/useInitialInfo';
import { calcShortcutIntervalWithinBoundary } from '@src/utils/calcShortcutInterval';
import { ESystemType } from '@src/emp-3.0/types';
let originalFilterData = {} as any;
let originalInterval = [] as any;
const EventLookerEasier: React.FC<{}> = () => {
  const { data: dimensionList } = useGetDimensionsList();
  const { appliedFilters, interval } = useSelector(commonSelector);
  const dispatch = useDispatch();

  const revertFilterAndInterval = () => {
    const filterData = {
      name: originalFilterData.name,
      rule: originalFilterData.rule,
      is_content: false,
    };
    const { from, to, shortcut } = originalInterval;
    dispatch(updateInterval(from, to, shortcut));
    dispatch(applyFilter(filterData));
  };

  const { empCalenderBoundry } = useInitialInfoStore();
  // revert filter state when dismount
  useEffect(() => {
    originalFilterData = cloneDeep(appliedFilters?.[0] ?? {});
    originalInterval = cloneDeep(interval);
    const [from, to] = calcShortcutIntervalWithinBoundary(
      DATE_SHORTCUTS.past24Hours,
      ESystemType.EMP,
    );
    dispatch(updateInterval(from.format(), to.format(), DATE_SHORTCUTS.past24Hours));
    const filterData = {
      name: 'Filters',
      rule: [],
      is_content: false,
    };
    dispatch(applyFilter(filterData));
    return () => {
      revertFilterAndInterval();
    };
  }, []);

  const dimensionTables = useMemo(() => {
    const dimensions = [
      {
        dimensionName: 'all_event_name',
        displayName: 'Raw Event',
        dimensionType: 'mapped',
        can_be_mapped: 1,
        dimension_id: 27,
        can_be_transform: 0,
      },
      {
        dimensionName: 'merged_event_tag_key',
        displayName: 'Tag Key',
        dimensionType: 'mapped',
        can_be_mapped: 1,
        dimension_id: 29,
        can_be_transform: 0,
      },
      {
        dimensionName: 'merged_event_tag_value',
        displayName: 'Tag Value',
        dimensionType: 'mapped',
        can_be_mapped: 1,
        dimension_id: 30,
        can_be_transform: 0,
      },
    ];
    return dimensions.map((dimension, index) => {
      const dimensionListData = dimensionList?.data ?? [];

      return (
        <DimensionTableContainer
          data={dimension}
          size={1}
          column={3}
          enableAction={false}
          key={`${dimension.dimensionName}/${index}`}
          dimensionList={dimensionListData}
          lockedDimensionNames={exploreLockedDimensionNames}
          // eventAttributeDimensionNames={eventAttributeDimensionNames}
          // transformPanelOpen={transformPanelOpen}
        />
      );
    });
  }, [
    dimensionList,
    // transformPanelOpen,
  ]);
  return (
    <DimensionContext.Provider value={{ column: 3, enableAction: false }}>
      <SummaryContainer calenderBoundry={empCalenderBoundry} isSharing={false} />
      <Line />
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>{dimensionTables}</div>
    </DimensionContext.Provider>
  );
};

export default EventLookerEasier;
